module.exports = __webpack_public_path__ + "img/alert_kvisit.9052218a.gif";